/**
 * Created by rak on 19/23/2016.
 */
'use strict';
angular.module('dashboard.driverWrkHrsSVG', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('DriverWrkHrsSVGWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.driverWhrkHrsSVG.title';
          },
          description: function () {
            return 'dashBoard.fleetManagement.driverWhrkHrsSVG.description';
          }
        },
        controller: 'DriverWrkHrsSVGCtrl',
        templateUrl: 'components/dashboard/driverWokingHoursSVG/driverWrkHrsSVGWidget.tpl.html',
        isSingleInstance: true,
        reload: true,
        config: {
          mapURL: null,
          height: 450
        },
        edit: {
          templateUrl: 'components/dashboard/driverWokingHoursSVG/driverWrkHrsSVGWidgetEdit.tpl.html',
          reload: false,
          controller: 'DriverWrkHrsSVGEditCtrl'
        }
      });
  }).service('DriverWrkHrsSVGWidgetService', function () {

    var _lastReadDeviceWorkingHours = null;
    this.setLastReadDeviceWorkingHours = function (rowdata) {
      _lastReadDeviceWorkingHours = rowdata;
    };
    this.getLastReadDeviceWorkingHours = function () {
      return _lastReadDeviceWorkingHours;
    };
  }).controller('DriverWrkHrsSVGCtrl', function ($scope, widgetSettingsCreatorService) {
    $scope.driverWrkHrsSVGDetails = {};
    $scope.isReady = true;
    var otherStyles = widgetSettingsCreatorService.fetchCustomerWidgetStyleSettings();
    $scope.driverWrkHrsSVGDetails.otherStyles = otherStyles;


  }).controller('DriverWrkHrsEditCtrl', function () {
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/driverWokingHoursSVG/driverWrkHrsSVGWidget.js